import React, { useState, useEffect, useRef } from "react";
import Header from "./components/Header";
import { Footer } from "./components/Footer";
import { Contactform } from "./components/Contactform";
import Slider from "react-slick";
import img02 from "./images/smart_tv3.png";
import img18 from "./images/FW+.webp";
import img19 from "./images/2iptv-1png.png";
import Okgoogle from "./images/okgoogle.webp";
import Icon01 from "./images/ad04.webp";
import Icon02 from "./images/ad05.webp";
import Icon03 from "./images/ad06.webp";
import Icon04 from "./images/ad07.webp";
import Icon05 from "./images/ad08.webp";
import Icon06 from "./images/ad09.webp";
import Banner01 from "./images/banner01.jpg";
import Banner02 from "./images/Banner02.jpg";
import Banner03 from "./images/Banner03.jpg";
import Banner04 from "./images/Banner04.jpg";
import Banner05 from "./images/Banner05.jpg";
import Banner06 from "./images/Banner06.jpg";
import BannerMobile01 from "./images/Banner01m.jpg";
import BannerMobile02 from "./images/Banner02m.jpg";
import BannerMobile03 from "./images/Banner03m.jpg";
import BannerMobile04 from "./images/Banner04m.jpg";
import BannerMobile05 from "./images/Banner05m.jpg";
import BannerMobile06 from "./images/Banner06m.jpg";
import Icon07 from "./images/Icon07.webp";
import Icon08 from "./images/Icon08.webp";
import setupbox from "./images/setupbox1.webp";
import setupbox2 from "./images/setupbox2.webp";
import Ftr01 from "./images/adfeature01.webp";
import Ftr02 from "./images/adfeature02.webp";
import Ftr03 from "./images/adfeature03.webp";
import Ftr07 from "./images/Ftr07.webp";
import Ftr05 from "./images/Ftr_05.webp";
import Ftr04 from "./images/Ftr_05+.jpeg";
import Ftrl01 from "./images/4khd.webp";
import Ftrl02 from "./images/dublyvision.webp";
import Ftrl03 from "./images/dubly-audio.webp";
import Ftrl05 from "./images/Ftrl05.webp";
import Ftrl06 from "./images/Ftrl06+.webp";
import Channels from "./images/channels+.webp";
import Playstore from "./images/playstore.webp";
import Okgooglecurve from "./images/okgooglecurve.webp";
import Voicesearch from "./images/voicesearch+.webp";
import Screenshare from "./images/screenshare.webp";
import { Ottslider } from "./components/Ottslider";
import Livetv from "./images/livetv.webp";
import Ultra4k from "./images/ultra4k.webp";
import Ultra4khd from "./images/4khd.webp";
import { Link, NavLink } from "react-router-dom";
import Plan_bg from "./images/Plan_Bg.webp";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Accordion, AccordionItem } from "react-light-accordion";

const faqs = [
  {
    q: "What is Netplus Dual Screen IPTV?",
    a: "Netplus Dual Screen IPTV is a broadband and entertainment service listed under Combo Plans (2 TV Screens). The current plans combine broadband internet, live TV channels, 17 OTT apps, and one mobile screen, with different speeds and live TV packages.",
  },
  {
    q: "What Netplus Dual Screen IPTV plans are available?",
    a: "The current Netplus Dual Screen IPTV page lists 50 Mbps, 60 Mbps, 100 Mbps, 150 Mbps, 200 Mbps, and 300 Mbps plans. The plans differ in pricing and live TV channel packages, while the listed plans include unlimited data, 17 OTT apps, and one mobile screen.",
  },
  {
    q: "How much do Netplus Dual Screen IPTV plans cost?",
    a: "The current listed prices range from ₹598 for the 50 Mbps plan to ₹1,498 for the 300 Mbps plan. The page also lists 60 Mbps plans at ₹798 and ₹849, 100 Mbps at ₹898, 150 Mbps at ₹998, and 200 Mbps at ₹1,248. Customers should check the current Netplus page for the latest pricing.",
  },
  {
    q: "Does Netplus Dual Screen IPTV support two TV screens?",
    a: "Yes. Netplus lists these services under “Combo Plans (2 TV Screens)” and labels the plans as Dual Screen. The listed plans are designed for two TV screens and also include one mobile screen.",
  },
  {
    q: "Does Netplus Dual Screen IPTV include unlimited data?",
    a: "Yes. The current Netplus Dual Screen IPTV plans displayed on the website include unlimited data. The individual plan details should be checked for the latest terms and benefits.",
  },
  {
    q: "How many OTT apps are included with Netplus Dual Screen IPTV plans?",
    a: "The current Dual Screen IPTV plans listed on the Netplus website include 17 OTT apps. The exact OTT services displayed can vary by plan, so customers should check the individual plan details for the current OTT bundle.",
  },
  {
    q: "What live TV channel packages are available with Netplus Dual Screen IPTV?",
    a: "The current Dual Screen plans include different live TV packages depending on the plan, including iFavourite, GOLD HD, iGOLD HD, PLATINUM HD, and HD+ live TV channels.",
  },
  {
    q: "What internet speeds are available with Netplus Dual Screen IPTV?",
    a: "The current Netplus Dual Screen IPTV page lists speeds of up to 50 Mbps, 60 Mbps, 100 Mbps, 150 Mbps, 200 Mbps, and 300 Mbps. The page states that both download and upload speeds are up to the listed plan speed.",
  },
  {
    q: "Are 3-month, 6-month, and 12-month plans available for Netplus Dual Screen IPTV?",
    a: "Yes. The current Dual Screen IPTV plans displayed on the Netplus website show 3-month, 6-month, and 12-month plan options.",
  },
  {
    q: "How can I get a Netplus Dual Screen IPTV connection?",
    a: "To get a Netplus Dual Screen IPTV connection, choose a Dual Screen plan on the Netplus website and use the Book Now option to submit your details. Netplus can then provide information about service availability, plan selection, and installation. You can also call +91-70875-70875.",
  },
];

export const Iptv2Faqs = () => (
  <>
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: {
              "@type": "Answer",
              text: f.a,
            },
          })),
        })}
      </script>
    </Helmet>

    <section id="faq">
      <div className="faq">
        <div
          className="container"
          style={{
            background: "#fff",
            backgroundImage: "none",
            marginTop: -100,
          }}
        >
          <div className="row">
            <div className="web-container">
              <div
                className="heading"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-easing="ease-in-sine"
              >
                <h4>Dual Screen IPTV Plans – Frequently Asked Questions</h4>
              </div>

              <div
                className="faqcont"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-easing="ease-in-sine"
              >
                <Accordion atomic={true}>
                  {faqs.map((f, i) => (
                    <AccordionItem key={i} title={`${i + 1}. ${f.q}`}>
                      <div className="accordiancont">
                        <p>{f.a}</p>
                      </div>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);
export const Iptv2 = () => {
  var decodeHTML = function (html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  function createMarkup(content) {
    return { __html: decodeHTML(content) };
  }

  var settings = {
    dots: true,
    navigation: true,
    loop: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "ease-in-out",

    // Add these
    centerMode: true,
    centerPadding: "150px",
  };

  var settingsMobile = {
    dots: true,
    navigation: true,
    loop: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "ease-in-out",
    centerMode: true,
    centerPadding: "30px",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 360,
        settings: {
          centerPadding: "12px",
        },
      },
    ],
  };
  const [pagedata, setPagedata] = useState([]);
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      const response = await axios.get(
        window.weburl + `api/plans.php?catID=16`,
      );
      if (mounted) {
        setPagedata(response.data);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  console.log(pagedata);
  if (pagedata.length === 0) {
    console.log("no data");
    // return null;
  }

  const [user_mobile, setusermobile] = useState();
  const [plans, setPlans] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const ref_mobile = useRef(null);
  const ref_plan = useRef(null);

  const [selectedPlan, setSelectedPlan] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_plans.php?cid=16")
      .then((response) => setPlans(response.data))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    axios
      .get(window.weburl + "api/get_states.php")
      .then((response) => setStates(response.data))
      .catch((error) => console.log(error));
  }, []);

  function getCities(state) {
    axios
      .get(window.weburl + `api/get_cities.php?sid=${state}`)
      .then((response) => setCities(response.data))
      .catch((error) => console.log(error));
  }

  const handledisable = () => {
    if (isValidPhone(user_mobile) && user_mobile) {
      const element = document.getElementById("submit_button_text");
      element.classList.remove("disabled");
      setIsDisabled(false);
    } else {
      const element = document.getElementById("submit_button_text");
      element.classList.add("disabled");
      setIsDisabled(true);
    }
  };

  function isValidPhone(phone) {
    const regex = /^[6-9]\d{9}$/gi;
    return regex.test(phone);
  }

  const handleSubmit = () => {
    if (!isValidPhone(user_mobile)) {
      alert("Please enter Mobile number");
      ref_mobile.current.focus();
      return false;
    }
    if (!selectedPlan) {
      alert("Please select plan");
      ref_plan.current.focus();
      return false;
    } else {
      document.getElementById("submit_button_text").innerText = "SUBMITTING...";
      const url = window.weburl + "api/insert_hook.php";
      let fData = new FormData();
      fData.append("user_phone", user_mobile);
      fData.append("catid", "16");
      fData.append("pid", selectedPlan);
      fData.append("user_state", selectedState);
      fData.append("user_city", selectedCity);
      fData.append("td_name", "iptv");
      fData.append("utm_url", window.location.href);
      axios
        .post(url, fData)
        .then((response) => {
          // ⭐⭐⭐ ADD GOOGLE ADS CONVERSION TAG HERE
          if (window.gtag) {
            window.gtag("event", "conversion", {
              // send_to: "AW-801924308/pEhpCICE9_4CENTJsf4C",
              send_to: "AW-801924308/HeMjCImtpfIbENTJsf4C",
            });
          }
          // ⭐⭐⭐ END TAG

          alert(response.data);
        })
        .catch((error) => alert(error));
      document.getElementById("submit_button_text").innerText = "SUBMIT";
      document.getElementById("user_mobile").value = "";
      document.getElementById("selectedPlan").value = "";
      document.getElementById("pid").value = "";
      document.getElementById("user_state").value = "";
      document.getElementById("user_city").value = "";
    }
  };

  return (
    <>
      <Header />
      <section
        id="banner"
        className="p-0 hbanner newbanner"
        data-aos="fade-left"
        data-aos-offset="200"
        data-aos-duration="600"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
        <div
          style={{
            width: "100%",
            position: "relative",
            marginTop: "120px",
            padding: "0 10px",
            boxSizing: "border-box",
          }}
        >
          {/* Desktop Slider */}
          <div className="banner-desktop">
            <Slider {...settings}>
              {[Banner06, Banner04, Banner05, Banner03, Banner01, Banner02].map(
                (banner, index) => (
                  <div key={index} style={{ padding: "0 8px" }}>
                    <img
                      src={banner}
                      alt={`Banner ${index + 1}`}
                      loading={index === 0 ? "eager" : "lazy"}
                      decoding="async"
                      fetchPriority={index === 0 ? "high" : "auto"}
                      draggable={false}
                      style={{
                        width: "100%",
                        display: "block",
                        objectFit: "cover",
                        borderRadius: "20px",
                      }}
                    />
                  </div>
                ),
              )}
            </Slider>
          </div>

          {/* Mobile Slider */}
          <div className="banner-mobile">
            <Slider {...settingsMobile}>
              {[
                BannerMobile06,
                BannerMobile04,
                BannerMobile05,
                BannerMobile03,
                BannerMobile01,
                BannerMobile02,
              ].map((banner, index) => (
                <div key={index} style={{ padding: "0 8px" }}>
                  <img
                    src={banner}
                    alt={`Banner ${index + 1}`}
                    loading={index === 0 ? "eager" : "lazy"}
                    decoding="async"
                    fetchPriority={index === 0 ? "high" : "auto"}
                    draggable={false}
                    style={{
                      width: "100%",
                      display: "block",
                      objectFit: "cover",
                      borderRadius: "20px",
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      {/* <section id='filter' className='p-0'>
                <div className='filter'>
                    <div className="container">
                        <div className="row">
                            <div className="web-container">
                                <div className="footerform" data-aos="fade-up" data-aos-offset="10" data-aos-duration="600" data-aos-once="true" data-aos-easing="ease-in-sine">
                                    <div className='heading'>
                                        <h4>Get it today</h4>
                                    </div>
                                    <div className="form">
                                        <ul>
                                            <li>
                                                <input type="text" name="user_mobile" id="user_mobile" placeholder='Mobile number*' pattern="[a-zA-Z\s]+" value={user_mobile} onChange={(e) => { setusermobile(e.target.value); }} onKeyUp={handledisable} ref={ref_mobile} />
                                            </li>
                                            <li><select name="selectedPlan" id="selectedPlan" value={selectedPlan} onChange={event => { setSelectedPlan(event.target.value); }} ref={ref_plan}>
                                                <option value="">Select Plan</option>
                                                {plans.map(plan => (
                                                    <option key={plan.sno} value={plan.sno} dangerouslySetInnerHTML={createMarkup(plan.pname + ' ' + plan.ptitle)}></option>
                                                ))}
                                            </select></li>
                                            <li><select name="selectedState" id="selectedState" value={selectedState} onChange={event => { setSelectedState(event.target.value); getCities(event.target.value); }}>
                                                <option value="">Select Region</option>
                                                {states.map(state => (
                                                    <option key={state.stateid} value={state.stateid}>{state.sname}</option>
                                                ))}
                                            </select></li>
                                            <li><select name="selectedCity" id="selectedCity" value={selectedCity} onChange={event => setSelectedCity(event.target.value)}>
                                                <option value="">Select City</option>
                                                {cities.map(city => (
                                                    <option key={city.cityid} value={city.cityid}>{city.cityname}</option>
                                                ))}
                                            </select></li>
                                            <li className='buttnprop'><input type="submit" value="" id="submit_button" disabled={isDisabled} onClick={handleSubmit} /><span id="submit_button_text" className='disabled'>SUBMIT</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

      <section id="androidtv" className="pt-0">
        <div className="androidtv">
          <div className="container">
            <div className="row">
              <div className="web-container">
                {/* <div className='androidtvrow'>
                                    <div className='androidtvrow3' data-aos="zoom-in" data-aos-offset="200" data-aos-duration="600" data-aos-once="true" data-aos-easing="ease-in-sine">
                                        <img src={setupbox2} alt='SetUp Box' />
                                    </div>
                                    <div className='androidbox7'>
                                        <div className='andoidcont' data-aos="fade-in" data-aos-offset="200" data-aos-duration="600" data-aos-once="true" data-aos-easing="ease-in-sine">
                                            <h4>A Smart way to watch</h4>
                                            <p>Your ultimate TV Experience awaits with FW+IPTV - Welcome to smarter way to watch your favourite content. Convert yout normal TV to smart TV and enjoy host of unlimited entertainment.</p>
                                            <div className='buttnprop'>
                                                <Link to='/book-now/bVhQYTVDZ1hCN3JkWnppc0g2N2lidz09'><span>Get Now</span></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                <br />
                <br />
                <br />
                <br />
                {pagedata.data ? (
                  <div className="planstab">
                    <div className="title m-0">
                      <span>Combo Plans(2 Tv Screens)</span>
                    </div>
                    <div className="planstabpanel">
                      <div className="androidtv" id="plans">
                        <div className="bundlestn">
                          {pagedata.data.map((getData) => {
                            const newValues = getData.features.split("|_");
                            return (
                              <div className="bundlebox">
                                <h4
                                  dangerouslySetInnerHTML={createMarkup(
                                    getData.pname,
                                  )}
                                ></h4>
                                <div className="image_plans_div">
                                  <div className="image_plan">
                                    <img src={Plan_bg} alt="Plan Image" />
                                  </div>
                                  <p
                                    dangerouslySetInnerHTML={createMarkup(
                                      getData.ptitle,
                                    )}
                                  ></p>
                                </div>

                                {getData.features ? (
                                  <ul>
                                    {newValues.map((featuresValue) => (
                                      <li
                                        dangerouslySetInnerHTML={createMarkup(
                                          featuresValue,
                                        )}
                                      ></li>
                                    ))}
                                  </ul>
                                ) : null}
                                <div className="price">
                                  <h6>{getData.price}</h6>
                                </div>

                                {getData.icon_values ? (
                                  <div className="entertainment">
                                    <Ottslider
                                      geticonValues={getData.icon_values}
                                    />
                                  </div>
                                ) : null}
                                <div className="buttnprop">
                                  <Link to={"/book-now/" + getData.plan_id}>
                                    <span>Book Now </span>
                                  </Link>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                <div
                  className="androidfeature"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <ul
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      gap: 50,
                      margin: 0,
                      padding: 0,
                      listStyle: "none",
                      width: "100%",
                    }}
                  >
                    {[
                      [Ftr07, Ftrl01],
                      [Ftr05, Ftrl06],
                      [Ftr04, Ftrl05],
                    ].map(([main, badge], i) => (
                      <li
                        key={i}
                        style={{
                          flex: "1 1 280px",
                          maxWidth: 400,
                          minWidth: 0,
                          position: "relative",
                          margin: 0,
                          padding: 0,
                          width: "auto",
                        }}
                      >
                        <span
                          style={{
                            display: "block",
                            position: "relative",
                            width: "100%",
                          }}
                        >
                          <img
                            src={main}
                            alt=""
                            width="397"
                            height="671"
                            style={{
                              display: "block",
                              width: "100%",
                              height: "auto",
                              aspectRatio: "397 / 671",
                              objectFit: "cover",
                              borderRadius: 25,
                            }}
                          />
                          <img
                            src={badge}
                            alt=""
                            style={{
                              position: "absolute",
                              bottom: 0,
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              width: "auto",
                              maxWidth: "60%",
                              height: "auto",
                              borderRadius: 0,
                            }}
                          />
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
                {/* <div className='planbanner'>
                                    <div className='plancont' data-aos="fade-up" data-aos-offset="200" data-aos-duration="600" data-aos-once="true" data-aos-easing="ease-in-sine">
                                        <h4>Plug and Play, Out Of The Way!</h4>
                                        <p>Connect and Access Umlimited Content</p>
                                    </div>
                                </div> */}
                {/* <div className='clearfix'></div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="androidpoints">
        <div className="androidpoints">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="heading"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <h4>FW+ TV Bundle</h4>
                </div>
                <div
                  className="gradienticons"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <ul>
                    <li>
                      <span>
                        <img src={Icon01} alt="" />
                      </span>
                      <p>7000+ Channels</p>
                    </li>
                    <li>
                      <span>
                        <img src={Icon02} alt="" />
                      </span>
                      <p>4K Ultra HD</p>
                    </li>
                    <li>
                      <span>
                        <img src={Icon07} alt="" />
                      </span>
                      <p>Bluetooth Remote</p>
                    </li>
                    {/* <li><span><img src={Icon08} alt='' /></span><p>Tango TV App</p></li> */}
                    <li>
                      <span>
                        <img src={Icon05} alt="" />
                      </span>
                      <p>Dual-Band</p>
                    </li>
                    <li>
                      <span>
                        <img src={Icon06} alt="" />
                      </span>
                      <p>Micro SD XC</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="androidbox" className="pt-0">
        <div className="androidbox">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="squarecont"
                  data-aos="fade-up"
                  data-aos-offset="200"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <ul>
                    <li>
                      <p>Apps you'll love on your TV</p>
                      <img src={Channels} alt="play store" />
                      <p>
                        Revolutionize your TV time with apps <br />
                        designed to redefine your TV experience.
                      </p>
                    </li>
                    <li>
                      <p>Control Your HD World with Voice Assistant</p>
                      <img src={Voicesearch} alt="play store" />
                      <p>
                        Combines the power of voice control with
                        <br />
                        the high-quality HD streaming.
                      </p>
                    </li>
                    <li>
                      <p>Stream your world in HD Excellence</p>
                      <img src={Livetv} alt="play store" />
                      <p>
                        Highlights the reliability of HD quality in
                        <br /> providing a superior viewing experience.
                      </p>
                    </li>
                    <li>
                      <p>Stunning ultra 4k picture quality</p>
                      <img src={Ultra4k} alt="play store" />
                      <p>
                        Experience Every Detail in Ultra 4K Brilliance
                        <br /> for Unmatched entertainment.
                        <br />
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Iptv2Faqs />

      {/* <Contactform /> */}
      <Footer />
    </>
  );
};
